import "./Itwork.css";
import Cta from "./Cta";
import Footer from "./Footer";
import { DollarSign, Globe, GraduationCap, Heart, TrendingUp } from "lucide-react";
import { Helmet } from 'react-helmet-async';
import { useLocation, Link } from "react-router-dom"; // <-- Import Link
import { useEffect, useState } from "react"; // <-- Import useState

const Itwork = () => {
  // State to track login status
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    // Check for login status from localStorage when the component mounts
    const loginStatus = localStorage.getItem('isLoginTrue');
    if (loginStatus === 'true') {
      setIsLoggedIn(true);
    }
    // Scroll to top on page change
    window.scrollTo(0, 0);
  }, [pathname]);

 
    return (
        <>
          <Helmet>
            <meta name="title" content="How It works | Get Next Visa - AI Powered Student Visa Report" />
            <title>How It works | Get Next Visa - AI Powered Student Visa Report</title>
            <meta name="description" content="Get personalized, AI-powered visa reports. Discover the best countries and colleges for your study abroad journey." />
          </Helmet>

              
            {/* section 1 */}
            <div className="work">
                <div className="work-content">
                    <h1>Say Hello to Hassle‑Free <br/>
                     <span className="highlight-text">  Study‑Abroad Planning</span>
                    </h1>
                    <p> Answer a few quick questions and our AI will craft your custom country, college & visa roadmap in under 3 minutes—no hidden fees, no busywork. </p>
                    
                    {/* --- MODIFICATION HERE --- */}
                    {isLoggedIn ? (
                      <Link to="/dashboard" className="start">
                        Start Your Journey
                      </Link>
                    ) : (
                      <button className="start trigger-login-popup">
                        Start Your Journey
                      </button>
                    )}
                </div>
            </div>


{/* section 2 */}

<div className="pro-mains">
<div className="smart-container">
  <section className="smart-section">
    <div className="smart-text section-numbered" data-number={1}>
      <h2>Complete Your Profile</h2>
      <p>
       Get started in under 2 minutes—tell us about you so our AI can work its magic.
       <ul>
          <li><b>Contact & Background:</b> Name, email, phone, and where you’re from</li>
          <li><b>Academic Snapshot:</b> Degrees, grades, and test scores</li>
          <li><b>Study Preferences:</b> Target countries, fields of study, and program type</li>
          <li><b>Budget & Timing:</b> Your spending range, ideal start date, and visa goals</li>
       </ul>
      </p>
    </div>
    <div className="smart-image">
      <img
        src="/photos/pp1.webp"
        alt="Germany visa document requirement"
      />
    </div>
  </section>
  <div className="decorative-line">
    <img
      src="/photos/linew.png"
      alt="Decorative line with stars"
      style={{ width: 500, maxWidth: "100%" }}
    />
  </div>


  <section className="smart-section reverse">
    <div className="smart-text section-numbered" data-number={2}>
      <h2>AI Analysis & Processing</h2>
      <p>
       Our AI compares your profile with 1,000+ universities to deliver:
        <ul>
          <li><b>Country Recommendations:</b> The best study destinations for your goals</li>
          <li><b>University Matches:</b> Institutions that align with your academic and financial profile</li>
          <li><b>Program Insights:</b> Top courses and specializations that fit your interests</li>
          <li><b>Visa Guidance:</b> Clear steps for obtaining your student visa in each country</li>

        </ul>
      </p>
    </div>
    <div className="smart-image">
      <img
        src="/photos/pp2.webp"
        alt="Germany visa document checklist"
      />
    </div>
  </section>
  <div className="decorative-line">
    <img
      src="/photos/linew.png"
      alt="Decorative line with stars"
      style={{ width: 500, maxWidth: "100%", transform: "scaleX(-1)" }}
    />
  </div>
  <section className="smart-section">
    <div className="smart-text smart-dep section-numbered" data-number={3}>
      <h2>Get Your Personalized Report</h2>
      <p>
       In just 3 minutes, receive your custom study‑abroad plan with:

        <ul>
           <li><b>Top Picks:</b>  Best country & college matches</li>
            <li><b>Cost Snapshot:</b> Tuition & living‑expense estimates</li>
            <li><b>Visa Path:</b> Step‑by‑step eligibility & timeline</li>
            <li><b>Funding Leads:</b> Scholarship matches (if eligible)</li>
        </ul>
      </p>
    </div>
    <div className="smart-image">
      <img
       src="/photos/pp3.webp"
        alt="Germany Work Permit process"
      />
    </div>
  </section>
  <div className="decorative-line">
    <img
      src="/photos/linew.png"
      alt="Germany PR process"
      style={{ width: 500, maxWidth: "100%" }}
    />
  </div>
  <section className="smart-section reverse">
    <div className="smart-text section-numbered" data-number={4}>
      <h2>Book an Expert Consultation</h2>
      <p>
        Speak one‑on‑one with our specialists—only if you need it—to:

<ul>
<li><b>Review Your Report:</b> Clarify any recommendations</li>
    <li><b>Plan Next Steps:</b> Applications, SOPs, and essays</li>

    <li><b>Visa Deep‑Dive:</b> Timelines, documents, and country rules</li>

    <li><b>Optional Help:</b> You choose if and when to schedule</li>
</ul>
           
      </p>
    </div>
    <div className="smart-image">
      <img
        src="/photos/pp4.webp"
        alt="PR in Germany"
      />
    </div>
  </section>
</div>
</div>



{/* section 6 */}

<div className="report-inclusions-container">
  <h2 className="report-inclusions-title">What's Included in Your Report</h2>
  <p className="report-inclusions-subtitle">
    Every report is comprehensive and tailored to your specific profile and
    goals.
  </p>
  <ul className="report-inclusions-list">
    <li className="report-inclusions-item">
      <svg
        className="checkmark-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
      </svg>
      Recommended Countries &amp; States
    </li>
    <li className="report-inclusions-item">
      <svg
        className="checkmark-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
      </svg>
      Top College Matches
    </li>
    <li className="report-inclusions-item">
      <svg
        className="checkmark-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
      </svg>
      Course Recommendations
    </li>
    <li className="report-inclusions-item">
      <svg
        className="checkmark-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
      </svg>
      Tuition Fees &amp; Scholarships
    </li>
    <li className="report-inclusions-item">
      <svg
        className="checkmark-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
      </svg>
      Part-time Job Opportunities
    </li>
    <li className="report-inclusions-item">
      <svg
        className="checkmark-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
      </svg>
      PR Opportunity Rating
    </li>
    <li className="report-inclusions-item">
      <svg
        className="checkmark-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
      </svg>
      Visa Requirements
    </li>
    <li className="report-inclusions-item">
      <svg
        className="checkmark-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
      </svg>
      Living Cost Breakdown
    </li>
    <li className="report-inclusions-item">
      <svg
        className="checkmark-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
      </svg>
      Area Lifestyle Insights
    </li>
    <li className="report-inclusions-item">
      <svg
        className="checkmark-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
      </svg>
      Flight Cost Estimates
    </li>
    <li className="report-inclusions-item">
      <svg
        className="checkmark-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
      </svg>
      Total Investment Calculator
    </li>
    <li className="report-inclusions-item">
      <svg
        className="checkmark-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
      </svg>
      Application Timeline
    </li>
    <li className="report-inclusions-item">
      <svg
        className="checkmark-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
      </svg>
      Post-study Work Pathways
    </li>
    <li className="report-inclusions-item">
      <svg
        className="checkmark-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
      </svg>
      Success Probability Analysis
    </li>
    <li className="report-inclusions-item">
      <svg
        className="checkmark-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
      </svg>
      Downloadable PDF Report
    </li>
  </ul>
</div>







       
            {/* section 7 */}

            <section className="why-sectionn">
                <div className="why-container1">
                    <h2 className="section-title">Smarter Study Abroad Planning</h2>
                    <p className="section-description">
                        At GetNextVisa, we combine powerful AI technology with human expertise to guide your education journey with clarity, accuracy, and confidence.               </p>
                    <div className="features-grid-new">
                        {/* Card 1 */}
                        <div className="event-card card-1">
                            <div className="card-header1" style={{
                                backgroundImage: `url(/photos/pop1.webp)`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                            }}>
                                <div className="card-icon-badge">
                <Globe className="icon" />
              </div>
                            </div>
                            <div className="card-body">
                                <div className="card-text-content">
                                    <h3 className="card-title">Smart Country Matching</h3>
                                    <p className="card-description">Our AI reviews your profile to suggest the best countries for your goals, lifestyle, and future opportunities. </p>
                                </div>
                                {/* <Heart className="heart-icon" /> */}
                            </div>
                        </div>

                        {/* Card 2 */}
                        <div className="event-card card-2">
                            <div className="card-header1" style={{
                                backgroundImage: `url(/photos/pop2.webp)`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                            }}>
                                <div className="card-icon-badge">
                <GraduationCap className="icon" />
              </div>
                            </div>
                            <div className="card-body">
                                <div className="card-text-content">
                                    <h3 className="card-title">University Recommendations</h3>
                                    <p className="card-description">We help you find the right universities that match your academic qualifications, budget,career plans. </p>
                                </div>
                                {/* <Heart className="heart-icon" /> */}
                            </div>
                        </div>

                        {/* Card 3 */}
                        <div className="event-card card-3">
                            <div className="card-header1" style={{
                                backgroundImage: `url(/photos/pop3.webp)`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                            }}>
                                <div className="card-icon-badge">
                <DollarSign className="icon" />
              </div>
                            </div>
                            <div className="card-body">
                                <div className="card-text-content">
                                    <h3 className="card-title">Cost & Budget Breakdown </h3>
                                    <p className="card-description">Know what to expect—get a full breakdown of tuition fees, living costs, and scholarship options. </p>
                                </div>
                                {/* <Heart className="heart-icon" /> */}
                            </div>
                        </div>

                        {/* Card 4 */}
                        <div className="event-card card-4">
                            <div className="card-header1" style={{
                                backgroundImage: `url(/photos/pop4.webp)`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                            }}>
                                <div className="card-icon-badge">
                <TrendingUp className="icon" />
              </div>
                            </div>
                            <div className="card-body">
                                <div className="card-text-content">
                                    <h3 className="card-title">Career & Salary Forecast </h3>
                                    <p className="card-description">See your future clearly with insights on job roles, salary expectations, and post-study work visa</p>
                                </div>
                                {/* <Heart className="heart-icon" /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>










            {/* section 8 */}
            <Cta />

            {/* <Footer /> */}
        </>
    )
}

export default Itwork